import { Controller } from "@hotwired/stimulus";

// Records where the rep is when the form loads (browser geolocation) into hidden fields.
// Best effort and silent: no geolocation support, a denied permission or a timeout leaves the
// fields blank and never blocks the form.
export default class extends Controller {
  static targets = ["latitude", "longitude"];

  connect() {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(this.fill.bind(this), () => {}, {
      timeout: 10000,
      maximumAge: 60000,
    });
  }

  fill({ coords }) {
    this.latitudeTarget.value = coords.latitude;
    this.longitudeTarget.value = coords.longitude;
  }
}
